"use client";

import { ActivityDisplayPreview } from "./previews";

type SnorkelingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function SnorkelingDisplay({
  data,
  participants,
}: SnorkelingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="snorkeling"
      data={data}
      participants={participants}
    />
  );
}
